module.exports = __webpack_public_path__ + "static/media/option-pick.a4ffc4c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/option-pick.png
// module id = 169
// module chunks = 0